module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/272.32e0c6b6.png";